// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { categoryDetailSubCategoriesStyles } from "@awc/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 14px 16px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
        }
        ${xScreen("lt", "sm")} {
            grid-template-columns: minmax(0, 1fr);
        }
        background-color: ${color("common.ui15")};
        border-radius: 52px;
        margin-bottom: 16px;
        padding: 16px 32px;
        width: 100%;
        max-width: 100%;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = {
    css: css`
        grid-column: 1 / -1;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {};

categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        css: css`
            &&& {
                line-height: ${fontConfig.lineHeight.singleLineSmall};
            }
        `,
    },
};

categoryDetailSubCategoriesStyles.skeletonStyle = {
    css: css`
        min-height: 100px;
        ${xScreen("lte", "sm")} {
            min-height: 170px;
        }
    `,
}

